import React, { ReactElement, useEffect, useId, useState } from "react";
import { TbPencilDown } from "react-icons/tb";
import oc from "open-color";

export default function AdditionalControlForm({
  defaultValue,
  label,
  unit,
  onSubmit,
  step,
}: {
  defaultValue?: number;
  label: string;
  unit?: string;
  onSubmit: (value: number) => Promise<void>;
  step?: number;
}): ReactElement {
  const [val, setVal] = useState<number>(defaultValue || 0);

  useEffect(() => {
    if (defaultValue !== undefined) {
      setVal(defaultValue);
    }
  }, [defaultValue]);

  const inputId = useId();

  return (
    <form
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onSubmit={async (e) => {
        e.preventDefault();
        await onSubmit(val);
      }}
    >
      <div className="form-group" style={{ marginBottom: "0" }}>
        <div
          className="d-flex"
          style={{ flexWrap: "wrap", alignItems: "center", justifyContent: "center", gap: "5px" }}
        >
          <div>
            <label htmlFor={inputId}>{label}:</label>
          </div>
          <div className="d-flex" style={{ alignItems: "center" }}>
            <input
              id={inputId}
              type="number"
              step={step || 0.01}
              className="form-control mr-2"
              style={{ width: "60px" }}
              value={val}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setVal(Number(e.target.value))}
            />
            <div style={{ marginRight: "5px" }}>{unit || ""}</div>
            <button
              type="submit"
              style={{ border: "none", background: "none", color: oc.blue[6] }}
            >
              <TbPencilDown size={24} />
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}
